import React from 'react';
import card_2c from './cards/2c.png';
import card_2d from './cards/2d.png';
import card_2h from './cards/2h.png';
import card_2s from './cards/2s.png';
import card_3c from './cards/3c.png';
import card_3d from './cards/3d.png';
import card_3h from './cards/3h.png';
import card_3s from './cards/3s.png';
import card_4c from './cards/4c.png';
import card_4d from './cards/4d.png';
import card_4h from './cards/4h.png';
import card_4s from './cards/4s.png';
import card_5c from './cards/5c.png';
import card_5d from './cards/5d.png';
import card_5h from './cards/5h.png';
import card_5s from './cards/5s.png';
import card_6c from './cards/6c.png';
import card_6d from './cards/6d.png';
import card_6h from './cards/6h.png';
import card_6s from './cards/6s.png';
import card_7c from './cards/7c.png';
import card_7d from './cards/7d.png';
import card_7h from './cards/7h.png';
import card_7s from './cards/7s.png';
import card_8c from './cards/8c.png';
import card_8d from './cards/8d.png';
import card_8h from './cards/8h.png';
import card_8s from './cards/8s.png';
import card_9c from './cards/9c.png';
import card_9d from './cards/9d.png';
import card_9h from './cards/9h.png';
import card_9s from './cards/9s.png';
import card_Ac from './cards/Ac.png';
import card_Ad from './cards/Ad.png';
import card_Ah from './cards/Ah.png';
import card_As from './cards/As.png';
import card_Jc from './cards/Jc.png';
import card_Jd from './cards/Jd.png';
import card_Jh from './cards/Jh.png';
import card_Js from './cards/Js.png';
import card_Kc from './cards/Kc.png';
import card_Kd from './cards/Kd.png';
import card_Kh from './cards/Kh.png';
import card_Ks from './cards/Ks.png';
import card_Qc from './cards/Qc.png';
import card_Qd from './cards/Qd.png';
import card_Qh from './cards/Qh.png';
import card_Qs from './cards/Qs.png';
import card_Tc from './cards/Tc.png';
import card_Td from './cards/Td.png';
import card_Th from './cards/Th.png';
import card_Ts from './cards/Ts.png';
import { getMediaUrl } from '../../utils/utils';

const cards = {
  '2c': card_2c,
  '2d': card_2d,
  '2h': card_2h,
  '2s': card_2s,
  '3c': card_3c,
  '3d': card_3d,
  '3h': card_3h,
  '3s': card_3s,
  '4c': card_4c,
  '4d': card_4d,
  '4h': card_4h,
  '4s': card_4s,
  '5c': card_5c,
  '5d': card_5d,
  '5h': card_5h,
  '5s': card_5s,
  '6c': card_6c,
  '6d': card_6d,
  '6h': card_6h,
  '6s': card_6s,
  '7c': card_7c,
  '7d': card_7d,
  '7h': card_7h,
  '7s': card_7s,
  '8c': card_8c,
  '8d': card_8d,
  '8h': card_8h,
  '8s': card_8s,
  '9c': card_9c,
  '9d': card_9d,
  '9h': card_9h,
  '9s': card_9s,
  'Ac': card_Ac,
  'Ad': card_Ad,
  'Ah': card_Ah,
  'As': card_As,
  'Jc': card_Jc,
  'Jd': card_Jd,
  'Jh': card_Jh,
  'Js': card_Js,
  'Kc': card_Kc,
  'Kd': card_Kd,
  'Kh': card_Kh,
  'Ks': card_Ks,
  'Qc': card_Qc,
  'Qd': card_Qd,
  'Qh': card_Qh,
  'Qs': card_Qs,
  'Tc': card_Tc,
  'Td': card_Td,
  'Th': card_Th,
  'Ts': card_Ts
};

export function Card({ card, className }) {
  const cardName = `${card.rank}${card.suit}`;

  return (
    <img src={getMediaUrl(cards[cardName])} alt={cardName} className={className} />
  );
}
